import React from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Button } from 'react-bootstrap';

const PdfWithHeaderExport = ({
    cols,
    formatDataForExport,
    getFormatedDataSet,
    name,
    buttonclass = 'btn',
    loading = false,
    grouppedData = false,
    size = 'a1', // use A1, A2, A3 or A4
    orientation = 'portrait', // portrait or landscape
    fontStyle = 'bold',
    backgroundColor = '#fff',
    buttonName = 'PDF Export',
    backendPdfUrl, // Optional: URL for backend PDF generation (used by mobile app)
}) => {
    const exportPDF = async (e) => {
        e.preventDefault();

        // Check if running in React Native WebView
        const isRN = !!window.ReactNativeWebView;

        if (isRN) {
            if (backendPdfUrl) {
                try {
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                            type: 'openUrl',
                            url: backendPdfUrl,
                        })
                    );
                    return;
                } catch (error) {
                    console.log('error: ', error);
                }
            }
        } else {
            // Generate PDF
            const unit = 'pt';
            const doc = new jsPDF(orientation, unit, size);
            doc.setFontSize(5);
            const headers = [cols.map((c) => c.label)];

            const dataSet = getFormatedDataSet();
            for (let i = 0; i < dataSet.length; i++) {
                const dataSetToFormat = dataSet[i].tableData;
                let formattedDataSet = await formatDataForExport(dataSetToFormat);
                if (!grouppedData) formattedDataSet = formattedDataSet.map((elt) => [...Object.values(elt)]);

                let content = {
                    head: headers,
                    body: formattedDataSet,
                    rowPageBreak: 'avoid',
                    styles: {
                        font: 'courier',
                        fontStyle,
                        halign: 'center',
                        valign: 'middle',
                    },
                    startY: 180,
                    margin: 10,
                };

                doc.setFontSize(16);

                const headerFields = dataSet[i].headerData;
                Object.keys(headerFields).map((title, i) => {
                    doc.setFont(undefined, 'bold');
                    doc.text(title || '', 75, 30 + 24 * i);
                    doc.setFont(undefined, 'normal');
                    doc.text(headerFields[title] || '', 300, 30 + 24 * i);
                });

                autoTable(doc, content);
                if (i < dataSet.length - 1) {
                    doc.addPage();
                }
            }
            doc.save(`${name}.pdf`);
        }
    };

    return (
        <Button
            key={1}
            className={buttonclass}
            disabled={loading}
            onClick={exportPDF}
            style={{ backgroundColor: `${backgroundColor} !important` }}
        >
            {buttonName}
        </Button>
    );
};

export default PdfWithHeaderExport;
